import { uint16, uint32, uint8 } from '../../utils';

export const genAnimationBin = (item: any) => {
  /**
   * typedef struct _anim_record_data {
   *     uint8_t attr_cnt;
   *     uint8_t flags;
   *     uint16_t select_method;
   *     uint16_t reserved;
   *     uint32_t reserved1;
   *     uint32_t data_len;
   *     struct _anim_attr {
   *          uint32_t len;
   *          uint8_t data[0];
   *     } attr[0];
   * } anim_record_data_t;
   */
  const { attr_cnt, select_method, data_len, attrs } = item;
  const flags = 0; // 保留位
  const reserved = 0; // 保留位

  const _anim_attr = attrs.map((attr: any) => {
    const { len, data } = attr;
    return Buffer.concat([uint32(len), data]);
  });

  const bin = Buffer.concat([
    uint8(attr_cnt),
    uint8(flags),
    uint16(select_method),
    uint32(reserved),
    uint32(data_len),
    Buffer.concat(_anim_attr)
  ]);
  return bin;
};
